import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  id: 'B1',
  title: 'La Semana Perfecta',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=320&q=60',
  desc: 'Organizador semanal diseñado para mujeres con trabajo, familia y poco tiempo. Tu entrenamiento entra en tu vida real.'
}, {
  id: 'B2',
  title: 'Comé Para Moverte',
  image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=320&q=60',
  desc: 'Guía de alimentación sin dietas extremas. Qué comer para tener energía, recuperarte mejor y rendir en cada sesión.'
}, {
  id: 'B3',
  title: 'Antiabandono',
  image: 'https://images.unsplash.com/photo-1538805060514-97d9cc17730c?auto=format&fit=crop&w=320&q=60',
  desc: 'Protocolo de rescate para las semanas difíciles. El sistema que evita que tires todo por la borda cuando la rutina se complica.'
}];
export function Bonuses() {
  return <section className="py-14 md:py-24 px-4 bg-brand-black relative" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-19">
          <div className="inline-block bg-brand-pink/10 text-brand-pink px-4 py-1.5 rounded-full text-xs md:text-sm font-bold tracking-wide mb-3 uppercase border border-brand-pink/20" data-id="element-20">
            INCLUIDOS GRATIS
          </div>
          <h2 className="text-3xl md:text-6xl text-white mb-3" data-id="element-21">
            3 BONOS <span className="text-brand-copper" data-id="element-22">ESTRATÉGICOS</span>
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-23">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-24">
          {bonuses.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-dark rounded-2xl border border-brand-copper/20 overflow-hidden flex sm:flex-col group hover:border-brand-pink/40 transition-colors" data-id="element-25">
              {/* Image */}
              <div className="relative flex-shrink-0 w-28 sm:w-full h-auto sm:h-32 overflow-hidden" data-id="element-26">
                <img src={bono.image} alt={bono.title} loading="lazy" decoding="async" width={320} height={240} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-27" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/20 to-transparent" data-id="element-28" />
                <span className="absolute top-2 left-2 bg-brand-pink text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase shadow" data-id="element-29">
                  Gratis
                </span>
              </div>

              {/* Content */}
              <div className="p-3.5 md:p-5 flex flex-col justify-center" data-id="element-30">
                <div className="text-brand-copper font-display text-sm mb-1 opacity-60" data-id="element-31">
                  {bono.id}
                </div>
                <h3 className="text-base md:text-xl text-white font-bold mb-1.5 leading-tight" data-id="element-32">
                  {bono.title}
                </h3>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed" data-id="element-33">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-dark border border-gray-800 rounded-xl p-4 md:p-6 text-center max-w-md mx-auto" data-id="element-34">
          <p className="text-gray-400 font-medium text-sm md:text-base" data-id="element-35">
            VALOR TOTAL:{' '}
            <span className="line-through text-gray-600" data-id="element-36">$24.000</span> —{' '}
            <span className="text-brand-pink font-bold" data-id="element-37">GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}